import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { RotatingSquare } from 'react-loader-spinner';
const WithdrawalMethodsEdit = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const editor = useRef(null)



    const refSubmitDis = useRef();

    const [results, setResults] = useState({});

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/withdrawal/method/view/${id}`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data)
            })
    }, [results]);


    const [errorMessage, setErrorMessage] = useState([]);


    const handleSubmitData = async (event) => {
        event.preventDefault();
        refSubmitDis.current?.setAttribute("disabled", true);

        try {
            const formData = new FormData(event.currentTarget);
            const InpuData = Object.fromEntries(formData);

            const response = await axios.put(
                `https://api.velormall.com/api/admin/withdrawal/method/update/${id}`,
                InpuData
            );

            event.target.reset();
            toast.success(response?.data?.message, {
                position: "top-right",
                autoClose: 5000,
                theme: "colored",
            });
            setResults(response);

        } catch (error) {
            // console.log("ERROR:", error);
            // Validation errors
            const errors = error?.response?.data?.errors;

            if (errors) {
                setErrorMessage(errors)
            } else {
                // General error
                toast.error(
                    error?.response?.data?.message || "Something went wrong",
                    {
                        position: "top-right",
                        autoClose: 5000,
                        theme: "colored",
                    }
                );
            }

        } finally {
            refSubmitDis.current?.removeAttribute("disabled");
        }
    };


    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Withdrawal Method Update</h6>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card mb-4">
                        <form onSubmit={handleSubmitData}>
                            <div className="card-body">
                                <div className="payment-method-item">
                                    <div className="payment-method-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">
                                                        Currency
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="currency"
                                                        id="heading"
                                                        defaultValue={data?.currency}
                                                    />
                                                </div>
                                                {errorMessage?.currency && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.currency?.msg}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">
                                                        Wallet Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="wallet_name"
                                                        defaultValue={data?.wallet_name}
                                                        id="heading"
                                                    />
                                                </div>
                                                {errorMessage?.wallet_name && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.wallet_name?.msg}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">
                                                        Withdrawal Address
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="withdrawal_address"
                                                        id="heading"
                                                        defaultValue={data?.withdrawal_address}
                                                    />
                                                </div>
                                                {errorMessage?.withdrawal_address && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.withdrawal_address?.msg}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">
                                                        Network
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="network"
                                                        defaultValue={data?.network}
                                                        id="heading"
                                                    />
                                                </div>
                                                {errorMessage?.network && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.network?.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button
                                    type="submit"
                                    ref={refSubmitDis}
                                    className="btn btn-primary w-100 h-45"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );


};


export default WithdrawalMethodsEdit;